import { takeLatest, put, call, select } from 'redux-saga/effects';
import CustomerActions, { CustomerTypes } from '../Redux/CustomerRedux';
import ApiResponseError from '../Services/ApiResponseError';

export function * getCustomers(api, {query}) {
    try {
        const response = yield call(api.getCustomerCollection, query);
        if (!response.ok) {
            throw new ApiResponseError(response);
        }

        const data = response.data.data;
        const pagination = data.pagination ? data.pagination : null;

        yield put(CustomerActions.fetchCustomersSuccess(data.customers, pagination));
    } catch (e) {
        yield put(CustomerActions.fetchCustomersFailure(e));
    }
}

export function * getFlatCustomers(api, {query}) {
    try {
        const response = yield call(api.getCustomerCollection, query);
        if (!response.ok) {
            throw new ApiResponseError(response);
        }
        yield put(CustomerActions.fetchFlatCustomersSuccess(response.data.data.customers));
    } catch (e) {
        yield put(CustomerActions.fetchFlatCustomersFailure(e));
    }
}

export function * createCustomer(api, {customer, query}) {
    try {
        const response = yield call(api.postCustomerCollection, customer);
        if (!response.ok) {
            throw new ApiResponseError(response);
        }
        yield put(CustomerActions.createCustomerSuccess(response.data.data.customer));
    } catch (e) {
        yield put(CustomerActions.createCustomerFailure(e));
    }
}

export function * getCustomer(api, {id, query}) {
    try {
        const response = yield call(api.getCustomerResource, id, query);
        if (!response.ok) {
            throw new ApiResponseError(response);
        }
        yield put(CustomerActions.fetchCustomerSuccess(response.data.data.customer));
    } catch (e) {
        yield put(CustomerActions.fetchCustomerFailure(e));
    }
}

export function * updateCustomer(api, {id, customer, query}) {
    try {
        const response = yield call(api.patchCustomerResource, id, customer, query);
        if (!response.ok) {
            throw new ApiResponseError(response);
        }
        yield put(CustomerActions.updateCustomerSuccess(response.data.data.customer));
    } catch (e) {
        yield put(CustomerActions.updateCustomerFailure(e));
    }
}

export function * deleteCustomer(api, {id, query}) {
    try {
        const response = yield call(api.deleteCustomerResource, id);
        if (!response.ok) {
            throw new ApiResponseError(response);
        }
        yield put(CustomerActions.deleteCustomerSuccess());
        yield call(getCustomers, api, {query});
    } catch (e) {
        yield put(CustomerActions.deleteCustomerFailure(e));
    }
}

export function * watchCustomer(api) {
    yield takeLatest(CustomerTypes.FETCH_FLAT_CUSTOMERS, getFlatCustomers, api);
    yield takeLatest(CustomerTypes.FETCH_CUSTOMERS, getCustomers, api);
    yield takeLatest(CustomerTypes.CREATE_CUSTOMER, createCustomer, api);
    yield takeLatest(CustomerTypes.FETCH_CUSTOMER, getCustomer, api);
    yield takeLatest(CustomerTypes.UPDATE_CUSTOMER, updateCustomer, api);
    yield takeLatest(CustomerTypes.DELETE_CUSTOMER, deleteCustomer, api);

    yield takeLatest(CustomerTypes.CREATE_CUSTOMER_SUCCESS, getCustomers, api);
}



// WEBPACK FOOTER //
// ./src/Sagas/CustomerSagas.js